const OutputDetails = ({ outputDetails }) => {
  const { status = {}, memory = '', time = '' } = outputDetails || {};

  return (
    <div className="metrics-container mt-4 flex flex-col space-y-3">
      <p className="text-sm">
        Status:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100">
          {status.description || '-'}
        </span>
      </p>
      <p className="text-sm">
        Memory:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100">
          {memory || '-'}
        </span>
      </p>
      <p className="text-sm">
        Time:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100">
          {time || '-'}
        </span>
      </p>
    </div>
  );
};

export default OutputDetails;
